// configures how the package will work. I had problems installing the package because of a dependency conflict so I installed an older version
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(HttpBackend) // To load translations from a server or file system
    .use(LanguageDetector) // To detect user's language
    .use(initReactI18next) // To initialize React i18next
    .init({
        fallbackLng: 'es', // Use English as fallback
        debug: true, // Enable debugging (optional)
        interpolation: {
            escapeValue: false, // React already escapes values
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to translation files
        },
        ns: ['main_page', 'header', 'footer', 'sobre_nosotros', 'centro_quiropractico', 'dosier_cientifico', 'aviso_legal', 'politica_cookies', 'politica_privacidad'], // Define all namespaces (these match the file names), then they are called in the specific files
        defaultNS: '', // Default namespace if not specified
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage', 'cookie'],
        },
    });

export default i18n;
